import urlRoute from '../../common/service/urlRoute';
import CONSTANTS from '../../common/constants/constants';

export const API = {
  VARIANTS_PATH: urlRoute.joinUrl(CONSTANTS.SPC_API_URL, '/variants/{modelId}'),
  VARIANT_DETAILS_PATH: urlRoute.joinUrl(CONSTANTS.SPC_API_URL, '/variant-details/{variantId}'),
  VARIANT_SPECIFICATIONS_PATH: urlRoute.joinUrl(CONSTANTS.SPC_API_URL, '/variant-specifications/{variantId}'),
  OPTIONS_PATH: urlRoute.joinUrl(CONSTANTS.SPC_API_URL, 'options/{carId}'),
  CURRENT_DEAL_PATH: urlRoute.joinUrl(CONSTANTS.DIGITAL_API_URL, 'api/current/deal'),
  CONFIGURE_DEAL_PATH: urlRoute.joinUrl(CONSTANTS.DIGITAL_API_URL, '/api/deals/configure-deal'),
  APPROVE_FINANCE_PATH: urlRoute.joinUrl(
    CONSTANTS.DIGITAL_API_URL,
    '/api/finance-calculator/v2/finance/undefined/approve',
  ),
  BASKET_INIT: urlRoute.joinUrl(CONSTANTS.PLATFORM_API_URL, '/basket/api/v1/init'),
  BASKET_INIT_V3: urlRoute.joinUrl(CONSTANTS.PLATFORM_API_URL, '/basket/api/v1/init-from-30'),
  BASKET_INIT_V3_COMPLEX: urlRoute.joinUrl(CONSTANTS.PLATFORM_API_URL, '/basket/api/v1/init-from-30-cm'),
  BASKET_SELECT_CAR: urlRoute.joinUrl(CONSTANTS.PLATFORM_API_URL, '/basket/api/v1/car'),
  BASKET_SELECT_INTERIOR: urlRoute.joinUrl(CONSTANTS.PLATFORM_API_URL, '/basket/api/v1/interior'),
  BASKET_SELECT_EXTERIOR: urlRoute.joinUrl(CONSTANTS.PLATFORM_API_URL, '/basket/api/v1/exterior'),
  BASKET_SELECT_STOCK_CAR: urlRoute.joinUrl(CONSTANTS.PLATFORM_API_URL, '/basket/api/v1/select-stock-car'),

  // from productConfigurator/constants/api
  CAR_DETAILS_PATH: urlRoute.joinUrl(CONSTANTS.SPC_API_URL, '/car-details/{carId}/{postcode}'),
  RESERVE_ONLINE: urlRoute.joinUrl(CONSTANTS.PLATFORM_API_URL, '/digital-api/api/reserve-online'),
  CONTINUE_IN_DEALERSHIP: urlRoute.joinUrl(CONSTANTS.PLATFORM_API_URL, '/digital-api/api/continue-in-dealership'),

  // from configuratorSummary/constants/api
  DEAL_SAVE_PATH: urlRoute.joinUrl(CONSTANTS.DIGITAL_API_URL, '/api/deals/save'),
};
